import type { SVGProps } from 'react';

const AlgoApisIcon = (props: SVGProps<SVGSVGElement>) => {
  const { fill = 'var(--brand-bg-primary)', ...restProps } = props;
  return (
    (<svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_2"
      data-name="Layer 2"
      viewBox="0 0 22 22"
      height={22}
      width={22}
      {...restProps}
      data-palette="AlgoApisIcon">
      <defs>
        <style>{`.cls-1{fill:${fill}}`}</style>
      </defs>
      <g id="Layer_1-2" data-name="Layer 1">
        <path
          d="M9.35 9.32c.51-.1.89.47.58.9-.27.37-.8.73-1.11 1.1l-.03.1 1.83 1.81c.1 0 .98-.99 1.16-1.13.55-.42 1.21.26.8.8l-1.16 1.16c.29.29.68.56.46 1.03-.73.7-1.32 1.53-2.28 1.93-.83.34-1.77.45-2.63.17-.32-.1-.6-.29-.91-.43l-1.6 1.58a.577.577 0 0 1-.81-.78l1.6-1.62c-.14-.31-.33-.59-.43-.91-.28-.87-.17-1.82.18-2.66.4-.95 1.23-1.53 1.92-2.25.46-.24.74.17 1.03.46.08 0 .94-.99 1.12-1.12.07-.05.2-.14.28-.15ZM7.2 11.45c-.36.4-.83.72-1.07 1.21-1.15 2.28.9 4.36 3.2 3.24.51-.25.83-.7 1.24-1.08L7.2 11.45ZM17.73 3.61c.53-.09.88.46.58.9l-1.57 1.58c.14.31.33.59.43.91.32 1 .12 2.21-.41 3.11-.22.38-1.28 1.5-1.63 1.76-.24.18-.48.14-.72-.04L10.18 7.6c-.18-.24-.22-.47-.04-.72.26-.36 1.38-1.41 1.76-1.63.9-.53 2.1-.73 3.11-.41.32.1.6.29.91.43L17.5 3.7c.06-.05.15-.09.22-.1Zm-3.92 2.21c-.44.03-1.03.22-1.39.46s-.66.65-.99.94l3.37 3.37c.24-.28.59-.54.82-.82 1.27-1.58.34-4.09-1.81-3.95Z"
          className="cls-1"
        />
        <path
          fill="currentColor"
          d="M4.26.01h13.39c2.28.23 4.1 2.06 4.35 4.34v13.28c-.22 2.3-2.05 4.16-4.35 4.4H4.39C2.09 21.8.24 19.97 0 17.67V4.31A4.936 4.936 0 0 1 4.26.01ZM2.47 19.52c.52.53 1.32.93 2.07.98h13.02c1.51-.2 2.71-1.4 2.91-2.91V4.55c-.13-1.55-1.37-2.81-2.91-3H4.54c-1.56.13-2.87 1.44-3 3v13.04c.11.72.42 1.42.93 1.93Z"
        />
      </g>
    </svg>)
  );
};
export default AlgoApisIcon;
